import { FunctionComponent, lazy, Suspense, useEffect, useState } from 'react'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import useShouldShowDevtoolsOnProd from '@hooks/useShouldShowDevtoolsOnProd'
import useEnableTrackingDebug from '@hooks/useEnableTrackingDedug'
import { setLocalStorageItem } from '@utils/localStorage'

const ReactQueryDevtoolsProduction = lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
)

const TanstackQueryDevtools: FunctionComponent = () => {
  const shouldShowDevtoolsOnProd = useShouldShowDevtoolsOnProd()
  const enableTrackingDebugLog = useEnableTrackingDebug()

  const [showProdDevtools, setShowProdDevtools] = useState<boolean>(
    process.env.NODE_ENV !== 'development' && shouldShowDevtoolsOnProd
  )

  useEffect(() => {
    setShowProdDevtools(
      process.env.NODE_ENV !== 'development' && shouldShowDevtoolsOnProd
    )
  }, [shouldShowDevtoolsOnProd])

  useEffect(() => {
    if (enableTrackingDebugLog) {
      setLocalStorageItem('reactQueryDevtoolsFilter', 'event-debugger')
      setLocalStorageItem('reactQueryDevtoolsSortFn', 'Last Updated')
      setLocalStorageItem('reactQueryDevtoolsBaseSort', '-1')
    }
  }, [enableTrackingDebugLog])

  return (
    <>
      <ReactQueryDevtools position="bottom" buttonPosition="bottom-left" />
      {showProdDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevtoolsProduction
            position="bottom"
            buttonPosition="bottom-left"
          />
        </Suspense>
      )}
    </>
  )
}

export default TanstackQueryDevtools
